import Link from "next/link";
import { FC } from "react";
import CloudLogo from "../logos/CloudLogo";
import CoreLogo from "../logos/CoreLogo";
import EngineLogo from "../logos/EngineLogo";
import IndexLogo from "../logos/IndexLogo";

type PlatformPageSummary = {
  icon: JSX.Element;
  name: "Cloud" | "Core" | "Engine" | "Index";
  text: JSX.Element;
};

const platformPageSummaries: PlatformPageSummary[] = [
  {
    icon: <IndexLogo />,
    name: "Index",
    text: (
      <span>
        Open-access <strong>models, behaviors, data </strong>
        and
        <strong> schemas</strong>
      </span>
    ),
  },
  {
    icon: <CoreLogo />,
    name: "Core",
    text: (
      <span>
        The integrated <strong>data and development</strong> environment
      </span>
    ),
  },
  {
    icon: <EngineLogo />,
    name: "Engine",
    text: (
      <span>
        The <strong>open simulation engine</strong> at the heart of HASH
      </span>
    ),
  },
  {
    icon: <CloudLogo />,
    name: "Cloud",
    text: (
      <span>
        One-click
        <strong> data processing </strong>
        and
        <strong> simulation</strong>
      </span>
    ),
  },
];

type PlatformExploreBannerProps = {
  exclude: PlatformPageSummary["name"];
};

const PlatformExploreBanner: FC<PlatformExploreBannerProps> = ({ exclude }) => {
  const summariesToRender = platformPageSummaries.filter(
    (summary) => summary.name !== exclude
  );

  return (
    <div className="platform-explore-banner">
      <div className="platform-explore-header container">
        <span>EXPLORE HASH</span>{" "}
        <span className="light-grey">SEE ALSO...</span>
      </div>
      <div className="platform-links-wrapper">
        <div className="platform-explore-links">
          {summariesToRender.map(({ name, icon, text }) => (
            <Link href={`/platform/${name.toLowerCase()}`} key={name}>
              <a className={`platform-explore-link ${name}`} key={name}>
                {icon}
                <div className="platform-explore-text">
                  <div className="platform-name">
                    <span className="bright-blue">h</span>
                    {name}
                  </div>
                  <p>{text}</p>
                </div>
              </a>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlatformExploreBanner;
